import React, { useEffect, useState, useRef } from 'react';

interface LoadMoreProps {
  options?: IntersectionObserverInit;
  loadMore: () => unknown;
  children: React.ReactChild | React.ReactChildren | React.ReactNode;
  className?: string;
}

const LoadMore: React.FC<LoadMoreProps> = ({
  options,
  children,
  className,
  loadMore,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isOnScreen, setIsOnScreen] = useState<boolean>(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    isOnScreen && loadMore();
  }, [isOnScreen]);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      ([entry]: IntersectionObserverEntry[]): void =>
        setIsOnScreen(entry.isIntersecting),
      options,
    );
  }, []);

  useEffect(() => {
    if (!ref.current) return;
    observerRef.current?.observe(ref.current);
    return () => {
      observerRef.current?.disconnect();
    };
  }, [ref]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

export default LoadMore;
